import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { ColorsStyle } from "../../config/colors";

declare const window: Window & { dataLayer: Record<string, unknown>[] };

export default function LandingHeader(){

	const navigate = useNavigate();

	return (
		<Navbar variant="dark" fixed="top" expand="lg" style={{backgroundColor: ColorsStyle.Opacity20, backdropFilter: 'blur(10px)'}}>
			<Container>
				<Navbar.Brand className="d-flex align-items-center" href="/1#inicio" onClick={()=>{ navigate("/1#inicio") }}>
					<img src="icon-transparent.png" alt="Logo Tribo Barber" style={{height: 60, filter: "drop-shadow(rgba(0, 0, 0, 0.9) 2px 2px 2px)"}}/>
				</Navbar.Brand>
				<Navbar.Brand className="d-flex d-lg-none tribo-barber text-warning d-flex align-items-center" href="/1#inicio" onClick={()=>{ navigate("/1#inicio") }} style={{textShadow: "2px 2px 2px #000000AA"}}>
					TRIBO BARBER
				</Navbar.Brand>
				<Navbar.Toggle/>
				<Navbar.Collapse>
					<Nav className="align-items-center me-auto">
						<Nav.Link className="fw-medium" href="/1#sobre" onClick={()=>{ navigate("/1#sobre") }} style={{textShadow: "2px 2px 2px #000000AA"}}>Sobre</Nav.Link>
						<Nav.Link className="fw-medium" href="/1#funcionalidades" onClick={()=>{ navigate("/1#funcionalidades") }} style={{textShadow: "2px 2px 2px #000000AA"}}>Funcionalidades</Nav.Link>
						<Nav.Link className="fw-medium" href="/1#depoimentos" onClick={()=>{ navigate("/1#depoimentos") }} style={{textShadow: "2px 2px 2px #000000AA"}}>Depoimentos</Nav.Link>
						<Nav.Link className="fw-medium" href="/1#comunidade" onClick={()=>{ navigate("/1#comunidade") }} style={{textShadow: "2px 2px 2px #000000AA"}}>Comunidade</Nav.Link>
					</Nav>
					<Nav className="align-items-center ms-auto">
						<Nav.Link className="fw-medium" onClick={()=>{ window.dataLayer.push({ event: 'install_android' }); }} href="https://apps.apple.com/br/app/tribo-barber/id1591303959" target="_blank" style={{textShadow: "2px 2px 2px #000000AA"}}>App Store</Nav.Link>
						<Nav.Link className="fw-medium" onClick={()=>{ window.dataLayer.push({ event: 'install_ios' }); }} href="https://play.google.com/store/apps/details?id=com.tribobarber" target="_blank" style={{textShadow: "2px 2px 2px #000000AA"}}>Google Play</Nav.Link>
						<Nav.Link className="fw-medium" onClick={()=>{ window.dataLayer.push({ event: 'contato' }); }} href="https://api.whatsapp.com/send?phone=555198984048" target="_blank" style={{textShadow: "2px 2px 2px #000000AA"}}>
							<Button className="fw-medium">Entre em Contato</Button>
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	)
}